import { render, staticRenderFns } from "./Referidos.vue?vue&type=template&id=5c0eb881&"
import script from "./Referidos.vue?vue&type=script&lang=js&"
export * from "./Referidos.vue?vue&type=script&lang=js&"
import style0 from "./Referidos.vue?vue&type=style&index=0&id=5c0eb881&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports